import { render, staticRenderFns } from "./ListedPunishmentItem.vue?vue&type=template&id=06edb7e2&scoped=true&"
import script from "./ListedPunishmentItem.vue?vue&type=script&lang=js&"
export * from "./ListedPunishmentItem.vue?vue&type=script&lang=js&"
import style0 from "./ListedPunishmentItem.vue?vue&type=style&index=0&id=06edb7e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06edb7e2",
  null
  
)

export default component.exports